import axios from 'axios';

// Pembatalan QRIS yang belum dibayar dari layar kasir. Transaksi QRIS sudah tercatat (menunggu bayar) begitu QR tampil; bila kasir
// menutup dialog atau pindah metode, transaksi itu dibatalkan (server ikut mematikan QR di Midtrans dan menolak bila ternyata sudah dibayar).

export const PESAN_BATAL_QRIS = 'QRIS belum dibayar. Batalkan QRIS ini? Pesanan tetap di keranjang.';

/** Hasil: { hasil: 'dibatalkan' | 'dibayar' | 'gagal', pesan? }. 'dibayar' = pelanggan ternyata sudah membayar (transaksi dihitung lunas). */
export async function batalkanQrisBelumBayar(baseUrl, transaksiUuid) {
  if (!transaksiUuid) return { hasil: 'dibatalkan' };
  try {
    await axios.patch(`${baseUrl}/canceltransaksi/${transaksiUuid}`, {}, { withCredentials: true });
    return { hasil: 'dibatalkan' };
  } catch (e) {
    const r = e?.response;
    if (r?.status === 409 && r.data?.sudahDibayar) return { hasil: 'dibayar' };
    if (r?.status === 400 && /sudah dibatalkan/i.test(r.data?.message || '')) return { hasil: 'dibatalkan' };
    return { hasil: 'gagal', pesan: r?.data?.message || 'Gagal membatalkan QRIS. Periksa koneksi lalu coba lagi.' };
  }
}
